import { connect } from "react-redux";
import B2bAlliance from "./b2bAlliance";
import { bindActionCreators } from "redux";

import { locationCity } from "services/redux/sales/corporate/locations/action";
import {
  getDropDownData,
  submitB2bData,
} from "services/redux/sales/preSales/b2bAlliance/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  cities: state.locationReducer.cities,
  dropDownData: state.preB2bReducer.dropDownData,
  allianceData: state.preB2bReducer.allianceData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      locationCity,
      getDropDownData,
      submitB2bData,
      documentUploadUrl,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(B2bAlliance);
